"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebSocket = void 0;
const socket_io_client_1 = require("socket.io-client");
class WebSocket {
    constructor(url, userId) {
        this.webSocket = null;
        this.url = url;
        this.userId = userId;
        this.connect();
    }
    connect() {
        if (!this.userId) {
            return null;
        }
        this.webSocket = (0, socket_io_client_1.io)(this.url, {
            transports: ['websocket'],
            query: { userId: String(this.userId) },
        });
    }
    on(eventName, callback) {
        if (!this.webSocket) {
            return;
        }
        this.webSocket.on(eventName, callback);
    }
    reconnect(data) {
        if ('userId' in data) {
            this.userId = data.userId;
        }
        this.connect();
    }
    isConnected() {
        return this.webSocket && this.webSocket.connected;
    }
}
exports.WebSocket = WebSocket;
